import { create } from 'zustand';

const SETTLE_MS = 2000;

let settleTimer: ReturnType<typeof setTimeout> | null = null;

const clearSettleTimer = () => {
  if (!settleTimer) return;

  clearTimeout(settleTimer);
  settleTimer = null;
};

const scheduleSettle = () => {
  clearSettleTimer();

  settleTimer = setTimeout(() => {
    const { inFlight } = useUnitRecalculationStore.getState();

    if (inFlight === 0) {
      useUnitRecalculationStore.setState({ isRecalculating: false });
    }

    settleTimer = null;
  }, SETTLE_MS);
};

interface IUnitRecalculationStore {
  inFlight: number;
  isRecalculating: boolean;
  begin: () => void;
  startRequest: () => void;
  endRequest: () => void;
}

export const useUnitRecalculationStore = create<IUnitRecalculationStore>((set, get) => ({
  inFlight: 0,
  isRecalculating: false,
  begin: () => {
    set({ isRecalculating: true });

    if (get().inFlight === 0) {
      scheduleSettle();
    } else {
      clearSettleTimer();
    }
  },
  startRequest: () => {
    clearSettleTimer();
    set({ inFlight: get().inFlight + 1 });
  },
  endRequest: () => {
    const inFlight = Math.max(0, get().inFlight - 1);
    set({ inFlight });

    if (inFlight === 0 && get().isRecalculating) {
      scheduleSettle();
    }
  },
}));
